import { AspectRatio, Box, Card, Image, SimpleGrid, Stack } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import Link from 'next/link';
import { games } from '../Shares/games';
export const CasinoGameList: React.FC = () => {
  const primes = games.find(item => item.id === 'primes');
  const isMobile = useMediaQuery('(max-width: 36em)');
  return <Card bg="var(--navbar-bg-color)" my={12} radius="sm">
      <Stack>
        {primes?.title}
        <SimpleGrid cols={{
        base: 3,
        sm: 5,
        lg: 7
      }}>
          {primes?.items.map(item => <AspectRatio key={item.id} ratio={isMobile ? 110 / 147 : 122 / 130}>
              <Box component={Link} href="#">
                <Image src={item.imgCard} radius="md" alt={`game-${item.id}`} />
              </Box>
            </AspectRatio>)}
        </SimpleGrid>
      </Stack>
    </Card>;
};